import React, { SVGProps } from "react"

const SmallCrownPlus = (props: SVGProps<SVGSVGElement>) => (
  <div style={{ position: "absolute", marginTop: "7px", marginLeft: "-8px" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="38"
      viewBox="0 0 36 38"
      fill="none"
      {...props}
    >
      <g filter="url(#filter0_d_8285_31008)">
        <path
          d="M16.2482 8.01142C17.3322 7.38555 18.6678 7.38555 19.7518 8.01142L26.6405 11.9886C27.7245 12.6145 28.3923 13.7711 28.3923 15.0228V22.9772C28.3923 24.2289 27.7245 25.3855 26.6405 26.0114L19.7518 29.9886C18.6678 30.6145 17.3322 30.6145 16.2482 29.9886L9.35952 26.0114C8.27549 25.3855 7.6077 24.2289 7.6077 22.9772V15.0228C7.6077 13.7711 8.27549 12.6145 9.35952 11.9886L16.2482 8.01142Z"
          fill="url(#paint0_linear_8285_31008)"
        />
        <path
          d="M19.708 8.08727L26.5967 12.0644C27.6536 12.6747 28.3047 13.8024 28.3047 15.0228V22.9772C28.3047 24.1976 27.6536 25.3253 26.5967 25.9356L19.708 29.9127C18.6511 30.5229 17.3489 30.5229 16.292 29.9127L9.40332 25.9356C8.34638 25.3253 7.69529 24.1976 7.69529 22.9772V15.0228C7.69529 13.8024 8.34638 12.6747 9.40332 12.0644L16.292 8.08727C17.3489 7.47705 18.6511 7.47705 19.708 8.08727Z"
          stroke="#FFDA57"
          strokeWidth="0.175182"
        />
      </g>
      <circle
        cx="18.0007"
        cy="18.9997"
        r="8.05276"
        fill="url(#paint1_linear_8285_31008)"
        stroke="#FFDA57"
        strokeWidth="0.175182"
      />
      <circle cx="18.0007" cy="19.001" r="7.50877" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8434 17.0106C18.8434 17.2511 18.7422 17.468 18.58 17.6209C18.9889 18.8657 20.3407 18.9739 20.8999 18.1923C20.7824 18.048 20.7119 17.8638 20.7119 17.6631C20.7119 17.1999 21.0874 16.8243 21.5507 16.8243C22.0139 16.8243 22.3894 17.1999 22.3894 17.6631C22.3894 18.0578 22.1168 18.3888 21.7496 18.4781C21.6307 19.4852 21.4645 20.0188 21.0638 20.7779V21.5933C21.0638 21.7301 20.9814 21.828 20.8291 21.828H18.0553H18.0025H15.1488C14.9965 21.828 14.9141 21.7301 14.9141 21.5933V20.7779C14.512 20.0161 14.3461 19.4814 14.227 18.4674C13.8716 18.3701 13.6104 18.0448 13.6104 17.6584C13.6104 17.1952 13.9859 16.8196 14.4491 16.8196C14.9124 16.8196 15.2879 17.1952 15.2879 17.6584C15.2879 17.8667 15.212 18.0572 15.0863 18.2038C15.654 18.9776 17.0078 18.8581 17.4054 17.5976C17.2572 17.4463 17.1658 17.2392 17.1658 17.0106C17.1658 16.5474 17.5414 16.1719 18.0046 16.1719C18.4678 16.1719 18.8434 16.5474 18.8434 17.0106Z"
        fill="#FFDA57"
      />
      <defs>
        <filter
          id="filter0_d_8285_31008"
          x="0.600367"
          y="0.886035"
          width="34.7993"
          height="36.9287"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.350365" />
          <feGaussianBlur stdDeviation="3.50365" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.855167 0 0 0 0 0.341667 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8285_31008"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_8285_31008"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_8285_31008"
          x1="7.87586"
          y1="6.0069"
          x2="26.2207"
          y2="29.4552"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAEF56" />
          <stop offset="0.475" stopColor="#F0B33F" />
          <stop offset="0.98" stopColor="#EEAC3C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8285_31008"
          x1="18.0007"
          y1="10.8594"
          x2="18.0007"
          y2="27.1401"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C145" />
          <stop offset="1" stopColor="#F6D54D" />
        </linearGradient>
      </defs>
    </svg>
  </div>
)

export { SmallCrownPlus }
